export default "__VITE_ASSET__9ecff443__"